module.exports = __webpack_public_path__ + "img/finscope-icon.6a57a43e.gif";